import React from 'react'

export default function Badge(props) {
    return (
        <>
         <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <div className='why-our-check-con'>
                    <div className='row g-0'>
                        <div className='col-2 col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2'>
                            <img src={props.badgeimg} alt={props.badgetitle} />
                        </div>
                        <div className='col-10 col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10'>
                            <div className='why-our-check-title'>{props.badgetitle}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};
